(() => {
  const initialize = (root) => {
    if (!root || root.dataset.tastingRedesignReady === 'true') return;
    root.dataset.tastingRedesignReady = 'true';

    const upcoming = root.querySelector('[data-tasting-upcoming]');
    if (upcoming) {
      [...upcoming.querySelectorAll('[data-tasting-upcoming-card]')]
        .sort((first, second) => Number(first.dataset.eventStart) - Number(second.dataset.eventStart))
        .forEach((card) => upcoming.append(card));
    }

    root.querySelectorAll('[data-tasting-month-events]').forEach((month) => {
      [...month.querySelectorAll('.delia-redesign-month__event')]
        .sort((first, second) => Number(first.dataset.eventStart) - Number(second.dataset.eventStart))
        .forEach((event) => month.append(event));
    });

    const archiveGrid = root.querySelector('[data-tasting-archive]');
    const archive = [...root.querySelectorAll('[data-tasting-archive-card]')];
    if (archiveGrid) {
      archive
        .sort((first, second) => Number(first.dataset.featureRank) - Number(second.dataset.featureRank))
        .forEach((card) => archiveGrid.append(card));
    }
    const initial = Math.max(1, Number(root.dataset.archiveInitial) || 8);
    archive.forEach((card, index) => { card.hidden = index >= initial; });

    const closeShare = (share) => {
      const trigger = share.querySelector('[data-share-trigger]');
      const menu = share.querySelector('[data-share-menu]');
      if (!menu) return;
      menu.hidden = true;
      trigger?.setAttribute('aria-expanded', 'false');
    };

    const openShare = (share) => {
      root.querySelectorAll('[data-delia-share]').forEach((other) => {
        if (other !== share) closeShare(other);
      });
      const trigger = share.querySelector('[data-share-trigger]');
      const menu = share.querySelector('[data-share-menu]');
      if (!menu) return;
      menu.hidden = false;
      trigger?.setAttribute('aria-expanded', 'true');
    };

    root.querySelectorAll('[data-delia-share]').forEach((share) => {
      const trigger = share.querySelector('[data-share-trigger]');
      const copy = share.querySelector('[data-share-copy]');
      const status = share.querySelector('[data-share-status]');
      const shareData = { title: share.dataset.shareTitle, url: share.dataset.shareUrl };

      trigger?.addEventListener('click', async () => {
        if (typeof navigator.share === 'function') {
          try {
            await navigator.share(shareData);
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }
        const menu = share.querySelector('[data-share-menu]');
        if (menu?.hidden) openShare(share);
        else closeShare(share);
      });

      copy?.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(shareData.url);
        } catch (_) {
          const input = document.createElement('textarea');
          input.value = shareData.url;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }
        if (status) status.textContent = share.dataset.shareCopied || '';
        closeShare(share);
        window.setTimeout(() => { if (status) status.textContent = ''; }, 2400);
      });
    });

    root.addEventListener('click', (event) => {
      root.querySelectorAll('[data-delia-share]').forEach((share) => {
        if (!share.contains(event.target)) closeShare(share);
      });
    });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('[data-delia-share]').forEach(closeShare);
    });

    const button = root.querySelector('[data-tasting-archive-more]');
    if (!button) return;
    if (archive.length <= initial) {
      button.hidden = true;
      return;
    }
    button.addEventListener('click', () => {
      archive.forEach((card) => { card.hidden = false; });
      button.hidden = true;
    }, { once: true });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-delia-tasting-redesign]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
